<template>
    <div class="configurator-container">
        <section class="configurator">
            <BunSelector></BunSelector>
            <BunCanvas></BunCanvas>
            <OptionFilter></OptionFilter>
        </section>
        <section class="recipes">
            <recipe-list></recipe-list>
        </section>
        <Loader></Loader>
        <ContactForm></ContactForm>
        <ModalCover></ModalCover>
    </div>
</template>

<script>
    import loaderMixin from "@/mixins/loaderMixin";
    import BunSelector from "@/components/BunSelector";
    import OptionFilter from "@/components/OptionFilter";
    import BunCanvas from "@/components/BunCanvas";
    import RecipeList from "@/components/RecipeList";
    import Loader from "@/components/Loader";
    import ContactForm from "../components/ContactForm";
    import ModalCover from "../components/ModalCover";

    export default {
        components: {
            ModalCover,
            ContactForm,
            RecipeList,
            BunCanvas,
            OptionFilter,
            BunSelector,
            Loader
        },
        mixins: [loaderMixin],
        beforeCreate() {
            // init store
            this.$store.commit('initialiseStore', initialData);

            // change locale
            this.$i18n.locale = this.$store.getters.locale();


            //preload loader images
            let loaderImg = new Image();
            loaderImg.src = '/src/img/loader.gif';

            let errorImg = new Image();
            errorImg.src = '/src/img/error.png';
        },
        mounted() {
          console.log('mounted new version')

            // check if current recipe is also given
            if(initialData.presetRecipe !== undefined) {
                // load bun
                this.$store.commit('selectBun', initialData.presetRecipe.bun);
                // load given recipe
                this.loadRecipe(initialData.presetRecipe);
            } else
                //check if recipe hash is given
                if (window.location.hash !== '') {
                    this.$store.dispatch('loadRecipe', window.location.hash.substr(1)).then((response) => {
                        if (response.data.success) {
                            this.loadRecipe(response.data.recipe);
                            this.$store.commit('showModalCover', false);
                        } else {
                            this.$store.commit('showModalCover', false);
                        }
                    });
                }
        }
    }
</script>
